/* RESPLANDOR — attribut de panier « Un petit mot »
   POST cart/update.js { attributes: { [name]: value } } au change.
   Custom element → se réinitialise automatiquement après les
   re-renders AJAX du drawer panier. */
if (!customElements.get("resplandor-cart-attribute")) {
  customElements.define(
    "resplandor-cart-attribute",
    class extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const input = event.target;
            if (!input.matches("[data-rs-attribute]")) return;
            const body = JSON.stringify({
              attributes: { [input.dataset.rsAttribute]: input.value },
            });
            fetch(FoxThemeSettings.routes.cart_update_url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body,
            });
          }, 300)
        );

        this.addEventListener("input", (event) => {
          const input = event.target;
          if (!input.matches("[data-rs-attribute]")) return;
          const counter = this.querySelector("[data-rs-char-count]");
          if (counter) counter.textContent = input.value.length;
        });

        this.collapsible = this.querySelector("collapsible-tab");
        const cancel = this.querySelector(".btn-cancel");
        if (cancel) {
          cancel.addEventListener("click", (e) => {
            e.preventDefault();
            if (this.collapsible) this.collapsible.close();
          });
        }
      }
    }
  );
}
